module.exports = __webpack_public_path__ + "static/media/home-road-dropoff-small_2x.952f5e72.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home-road-dropoff-small_2x.png
// module id = 1526
// module chunks = 27